import type { SchemaInput } from './schema-input.js';
import { isString } from './runtime-values.js';

export const MAX_MAP_IMAGES = 20;
export const MAP_IMAGE_ASSET_ID_PATTERN = /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/u;
export function isMapImageDataUrl(value: SchemaInput): value is string {
  return isString(value) && value.length <= 15_000_000 && /^data:image\/(?:png|jpeg|webp|gif|avif);base64,[A-Za-z0-9+/]+={0,2}$/.test(value);
}

/** Large file imports keep image pixels in the local draft, not in the URL. */
export function mapDraftLinkContent(compact: string) {
  const value = JSON.parse(compact);
  if (Array.isArray(value.i)) value.i = value.i.filter((image: { d?: string }) => !image.d);
  return value;
}
